var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "breadcrumb-layout" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { separator: "/" } },
          [
            _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
              _vm._v("首页")
            ]),
            _vm._v(" "),
            _c("el-breadcrumb-item", [_vm._v("询价单详情")])
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "swb-back-row" }, [
      _c("div", { staticClass: "simple-form" }, [
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("div", {}, [_vm._v(_vm._s(_vm.priceInpryInfo.form - _vm.label))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("div", {}, [_vm._v(_vm._s(_vm.priceInpryInfo.peerMerchantName))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(2),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("div", {}, [_vm._v(_vm._s(_vm.priceInpryInfo.publishTime))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(3),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("div", {}, [_vm._v(_vm._s(_vm.priceInpryInfo.expireDate))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(4),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _vm.priceInpryInfo.deliverPeriod != null
              ? _c("div", {}, [
                  _vm._v(_vm._s(_vm.priceInpryInfo.deliverPeriod) + "  天")
                ])
              : _c("div", [_vm._v("无")])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(5),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("div", {}, [_vm._v(_vm._s(_vm.priceInpryInfo.contactName))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(6),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("div", {}, [_vm._v(_vm._s(_vm.priceInpryInfo.contactTel))])
          ])
        ]),
        _vm._v(" "),
        _vm.priceInpryInfo.goodsFlag == true
          ? _c("div", { staticClass: "form-group center" }, [
              _vm._m(7),
              _vm._v(" "),
              _c("div", { staticClass: "form-value" }, [
                _c(
                  "div",
                  { staticClass: "table-layout" },
                  [
                    _c(
                      "el-table",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          data: _vm.priceInpryInfo.goodsList,
                          border: ""
                        }
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "goodsImage",
                            width: "150",
                            label: "商品图片",
                            align: "center"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  _c("img", {
                                    attrs: { src: rows.row.goodsImage }
                                  })
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "name",
                            label: "商品名称",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "quantity",
                            label: "数量",
                            width: "100",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "price",
                            label: "市场单价(元)",
                            width: "150",
                            align: "center"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.priceNegoFlag == 0
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            parseFloat(rows.row.price).toFixed(
                                              2
                                            )
                                          )
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  rows.row.priceNegoFlag == 1
                                    ? _c("span", [_vm._v("面议")])
                                    : _vm._e()
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "total",
                            label: "小计(元)",
                            width: "200",
                            align: "center"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.priceNegoFlag == 0
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            parseFloat(
                                              rows.row.quantity * rows.row.price
                                            ).toFixed(2)
                                          )
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  rows.row.priceNegoFlag == 1
                                    ? _c("span", [_vm._v("面议")])
                                    : _vm._e()
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "caozuo",
                            label: "操作",
                            width: "100",
                            align: "center"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "swb-btn-link",
                                      on: {
                                        click: function($event) {
                                          _vm.toPriceComparison(
                                            rows.row.id,
                                            rows.row.skuId
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("比价")]
                                  )
                                ]
                              }
                            }
                          ])
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.priceInpryInfo.servcFlag == true
          ? _c("div", { staticClass: "form-group center" }, [
              _vm._m(8),
              _vm._v(" "),
              _c("div", { staticClass: "form-value" }, [
                _c(
                  "div",
                  { staticClass: "table-layout" },
                  [
                    _c(
                      "el-table",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          data: _vm.priceInpryInfo.servcList,
                          border: ""
                        }
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "servcImage",
                            width: "150",
                            label: "服务图片",
                            align: "center"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  _c("img", {
                                    attrs: { src: rows.row.servcImage }
                                  })
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "name",
                            label: "服务名称",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "price",
                            label: "市场单价(元)",
                            width: "150",
                            align: "center"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        parseFloat(rows.row.price).toFixed(2)
                                      )
                                    )
                                  ])
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "total",
                            label: "小计(元)",
                            width: "200",
                            align: "center"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        parseFloat(rows.row.price).toFixed(2)
                                      )
                                    )
                                  ])
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "caozuo",
                            label: "操作",
                            width: "100",
                            align: "center"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "swb-btn-link",
                                      on: {
                                        click: function($event) {
                                          _vm.toServcComparison(
                                            rows.row.id,
                                            rows.row.ssuId
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("比价")]
                                  )
                                ]
                              }
                            }
                          ])
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(9),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value" },
            [
              _vm.forGoods != null || _vm.forServc != null
                ? _c("swb-create-trade-rule", {
                    ref: "swb_create_trade_rule",
                    attrs: {
                      comparedTradeRuleList: _vm.comparedTradeRuleList,
                      type: _vm.type,
                      operate: _vm.tradeOperate,
                      forPriceInqry: _vm.forPriceInqry,
                      forGoods: _vm.forGoods,
                      forServc: _vm.forServc
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "form-toolbar",
        on: {
          click: function($event) {
            _vm.goBack()
          }
        }
      },
      [
        _c("button", { staticClass: "swb-btn swb-btn-small swb-btn-primary" }, [
          _vm._v("返回")
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("询价标题")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("被询价方")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("询价时间")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("截至日期")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("要求交付期")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("联系人")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("联系电话")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("询价商品")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("询价服务")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("交易规则")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35a457f8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35a457f8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/priceInpry/PriceInpryInfo.vue
// module id = 3285
// module chunks = 0